// Extends From
import PostsSerializer from './base';
// Ember Imports
import { isEmpty } from '@ember/utils';
// External imports
import CommentModerationStatus from '@linc-technologies/linced-common/enums/comment-moderation-status';

export default class Comment extends PostsSerializer {
  // Sets as default
  normalize(modelClass, resourceHash) {
    if (isEmpty(resourceHash.moderationStatus)) {
      resourceHash.moderationStatus = CommentModerationStatus.UNSPECIFIED;
    }

    return super.normalize(...arguments);
  }
}
